import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'regulateTags'
})
export class RegulateTagsPipe implements PipeTransform {

  transform(value: any, meta: any) {
    const tagObj = {}

    for (const tag of meta.tagslist) {
      tagObj[tag.val]=tag.disp
    }
    const tagarr = []
    for (const key in value) {
      tagarr.push(tagObj[value[key]])
    }
    return tagarr;
  }
}